import React, { useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  FlatList,
} from "react-native";
import { fonts } from "../../common/styles/fonts";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header";
import { colors } from "../../common/styles/colors";
import { ArrowLeft } from "../../common/icons/ArrowLeft";
import { UserAvatar } from "../../components/user-avatar";
import { Settings } from "../../common/icons/Settings";
import {
  SubscriptionCard,
  SubscriptionType,
} from "../../components/SubscriptionCard";
import { EditProfile } from "../../components/EditProfile";
import { WINDOW_HEIGHT, useIsDesktop } from "../../utils/useIsDesktop";
import useUniqueDispatch, { useSelector } from "../../utils/redux-utils";
import {
  userDeleteMeAction,
  userLogoutAction,
  userUpdateMeAction,
} from "../../store/user/action";
import { RootState } from "../../store/root-reducer";
import { CommonButton } from "../../components/buttons";

export const ProfilePage = () => {
  const navigate = useNavigate();

  const isDesktop: boolean = useIsDesktop();

  const [activeSubscription, setActiveSubscription] =
    useState<SubscriptionType | null>(null);
  const subscriptions = subscriptionsList;

  const user = useSelector((store: RootState) => store.user);

  const [showEdit, setShowEdit] = useState(false);

  const [logoutToken, logout] = useUniqueDispatch(userLogoutAction.request);
  const [deleteMeToken, deleteMe] = useUniqueDispatch(
    userDeleteMeAction.request
  );

  const onDeleteEdit = () => {
    deleteMe([{}]);
    navigate("../subscription/welcome", { replace: true });
  };

  const chatRoute = () => {
    navigate("../subscription/chat");
  };

  const mapRoute = () => {
    navigate("../subscription/map");
  };

  return (
    <View style={[styles.screen]}>
      <Header
        containerStyle={[{ maxWidth: 790 }, !isDesktop && { paddingLeft: 21 }]}
        onPressRight={() => {
          logout([{}]);
          navigate("../subscription/welcome", { replace: true });
        }}
        rightButton={
          !isDesktop && (
            <Text style={[fonts.mediumText_regular, { color: colors.black }]}>
              Exit
            </Text>
          )
        }
        leftButton={
          <TouchableOpacity
            onPress={chatRoute}
            style={{ flexDirection: "row", alignItems: "center" }}
          >
            <ArrowLeft style={{ marginRight: 4 }} />

            <Text
              style={[fonts.mediumText_regular, { color: colors.noteGray }]}
            >
              back
            </Text>
          </TouchableOpacity>
        }
      />

      <ScrollView
        style={styles.verticalScroll}
        contentContainerStyle={{ alignItems: "center" }}
      >
        {showEdit ? (
          <EditProfile
            onCancel={() => setShowEdit(false)}
            onSave={() => setShowEdit(false)}
            onDelete={() => onDeleteEdit()}
          />
        ) : (
          <View
            style={[
              styles.upperContainer,
              isDesktop && { paddingHorizontal: 0 },
            ]}
          >
            <View style={styles.userContainer}>
              <UserAvatar
                user={user?.data}
                style={{ marginRight: 12 }}
                size={82}
              />
              <View>
                <Text
                  style={[fonts.mediumText_medium, { color: colors.black }]}
                >
                  {user?.data?.first_name}
                </Text>
                <Text
                  style={[fonts.mediumText_medium, { color: colors.black }]}
                >
                  {user?.data?.second_name}
                </Text>
              </View>
            </View>
            <TouchableOpacity
              onPress={() => {
                setShowEdit(true);
              }}
            >
              <Settings style={{ marginLeft: 12 }} />
            </TouchableOpacity>
            {isDesktop && (
              <Text
                onPress={() => {
                  logout([{}]);
                  navigate("../subscription/welcome", { replace: true });
                }}
                style={[
                  fonts.mediumText_regular,
                  { color: colors.black, marginLeft: "auto" },
                ]}
              >
                Exit
              </Text>
            )}
          </View>
        )}
        <View
          style={[
            styles.offersTitleContainer,
            isDesktop && { paddingHorizontal: 0 },
          ]}
        >
          {activeSubscription ? (
            <Text style={[fonts.mediumLargeText_bold, { color: colors.black }]}>
              Available upgrades ({subscriptions?.length - 1})
            </Text>
          ) : (
            <Text style={[fonts.mediumLargeText_bold, { color: colors.black }]}>
              Hottest offers!
            </Text>
          )}
          <Text
            style={[
              fonts.mediumLargeText_medium,
              { color: colors.blue50, textDecorationLine: "underline" },
            ]}
          >
            FAQ
          </Text>
        </View>

        <TouchableOpacity onPress={mapRoute}>
          <Text style={[fonts.mediumLargeText_medium, { color: colors.black }]}>
            To map
          </Text>
        </TouchableOpacity>

        <FlatList
          style={!activeSubscription && !isDesktop && { width: "100%" }}
          contentContainerStyle={[
            styles.offers,
            isDesktop && styles.offers_desktop,
          ]}
          data={subscriptions}
          horizontal={isDesktop}
          renderItem={({ item }) => (
            <>
              {activeSubscription?.id !== item.id && (
                <SubscriptionCard
                  buttonText={
                    activeSubscription
                      ? activeSubscription.id > item.id
                        ? "Downgrade"
                        : "Upgrade"
                      : undefined
                  }
                  subscription={item}
                  containerStyle={{
                    marginHorizontal: isDesktop ? 22 : 0,
                  }}
                  onSubscribe={() => setActiveSubscription(item)}
                />
              )}
            </>
          )}
        />
        {!!activeSubscription && (
          <View
            style={[
              styles.activeSubscriptionsContainer,
              isDesktop && styles.activeSubscriptionsContainer_desktop,
            ]}
          >
            <Text
              style={[
                fonts.mediumLargeText_bold,
                {
                  color: colors.black,
                  marginBottom: 24,
                  alignSelf: "flex-start",
                },
              ]}
            >
              Subscriptions
            </Text>
            {!!activeSubscription && (
              <SubscriptionCard subscription={activeSubscription} />
            )}
          </View>
        )}
      </ScrollView>
    </View>
  );
};

const subscriptionsList: Array<SubscriptionType> = [
  {
    id: 1,
    title: "Starter eater",
    type: "start",
    price: "$2",
    features: [
      {
        available: true,
        name: "A wise choice, mate! Its ammo will penetrate just about anything!",
      },
      {
        available: true,
        name: "*laughs* Thank you!",
      },
      {
        available: true,
        name: "Come back anytime.",
      },
      {
        available: false,
        name: "Welcome!",
      },
      {
        available: false,
        name: "Not enough cash, stranger!",
      },
      {
        available: false,
        name: "Got some rare things on sale, stranger!",
      },
    ],
  },
  {
    id: 2,
    title: "Medium eater",
    type: "medium",
    price: "$5",
    features: [
      {
        available: true,
        name: "A wise choice, mate! Its ammo will penetrate just about anything!",
      },
      {
        available: true,
        name: "*laughs* Thank you!",
      },
      {
        available: true,
        name: "Come back anytime.",
      },
      {
        available: false,
        name: "Welcome!",
      },
      {
        available: false,
        name: "Not enough cash, stranger!",
      },
      {
        available: false,
        name: "Got some rare things on sale, stranger!",
      },
    ],
  },
  {
    id: 3,
    title: "Premium eater",
    type: "premium",
    price: "$10",
    features: [
      {
        available: true,
        name: "A wise choice, mate! Its ammo will penetrate just about anything!",
      },
      {
        available: true,
        name: "*laughs* Thank you!",
      },
      {
        available: true,
        name: "Come back anytime.",
      },
      {
        available: false,
        name: "Welcome!",
      },
      {
        available: false,
        name: "Not enough cash, stranger!",
      },
      {
        available: false,
        name: "Got some rare things on sale, stranger!",
      },
    ],
  },
];

const styles = StyleSheet.create({
  screen: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    height: WINDOW_HEIGHT,
  },
  verticalScroll: {
    paddingBottom: 20,
    width: "100%",
  },
  userContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: 0,
  },
  upperContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    maxWidth: 790,
    width: "100%",
    paddingHorizontal: 16,
    marginBottom: 24,
  },
  offersTitleContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    maxWidth: 790,
    width: "100%",
    paddingHorizontal: 16,
  },
  offers: {
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 12,
    paddingTop: 24,
    paddingHorizontal: 16,
  },
  offers_desktop: {
    paddingHorizontal: 0,
    flexDirection: "row",
  },
  activeSubscriptionsContainer: {
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    maxWidth: 790,
    paddingHorizontal: 16,
  },
  activeSubscriptionsContainer_desktop: {
    paddingHorizontal: 0,
    alignItems: "flex-start",
  },
});
